<script>
    // @ts-nocheck

    import interface_element_translations from "./interface_element_translations.json";

    export let survey_is_complete = false;

    // is the form currently submitting? (set by form event [in Survey.svelte])
    export let submitting = false;

    export let user_language;
</script>

<input
    type="submit"
    style:visibility={survey_is_complete ? "" : "hidden"}
    disabled={submitting}
    value={interface_element_translations["submit"][user_language]}
/>

{#if submitting}
    <div id="submittingpopover">
        {interface_element_translations["submitting_message"][user_language]}
    </div>
    <div id="submittingpopoverbackdrop"></div>
{/if}

<style>
    #submittingpopover {
        position: fixed;
        top: 25vh;
        left: 25vw;
        width: 50vw;
        height: fit-content;
        padding: 2rem;
        background-color: white;
        border-radius: 1em;
        z-index: 1000;
    }

    #submittingpopoverbackdrop {
        background-color: rgba(0, 0, 0, 0.7);
        transition: opacity 0.3s;
        z-index: 999;
        position: fixed;
        left: 0;
        top: 0;
        width: 100vw;
        height: 100vh;
    }
</style>
